import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import rest from '../../rest'
import { requerAtencao, sortReportes, tamanhoMaiorSigla } from '../../util/reportes'
import { Sigla } from '../../components/Sigla'
import Error from '../../components/error'
import { Tag } from '../../components/tag/styles'
import * as S from './styles'
import Loading from '../../components/loading'
import { EllipsisParagraph } from '../../components/EllipsisParagraph'
import { Print } from '../../components/Print'
import { Button, Segment } from 'semantic-ui-react'
import chroma from 'chroma-js'
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css"
import "swiper/components/navigation/navigation.min.css"

import "./styles.scss";

import SwiperCore, {
  Pagination,Navigation
} from 'swiper/core';
import { StorePrioritarioType } from '../FormPrioritario/types'

// install Swiper modules
SwiperCore.use([Pagination,Navigation]);

type Reporte = {
  id: number
  ultimos_andamentos: string
  necessidade_apoio: string
  departamento: Departamento
  reporte_obrigatorio: boolean
  requer_atencao: boolean
  atualizado_por_colaborador: Colaborador
  atualizado_em: string
  sigla_departamento: string
}

type Departamento = {
  sigla: string
}

type Colaborador = {
  nome: string
}

export default function Viewer() {
  const [error, setError] = useState<any | null>()
  const [isLoaded, setIsLoaded] = useState(false)
  const [item, setItem] = useState<StorePrioritarioType>()
  const [reportes, setReportes] = useState<[Reporte]>()
  const history = useHistory()
  const [style, setStyle] = useState<{}>()

  let { id } = useParams<{ id: string }>()

  useEffect(() => {
    rest(`tema-prioritario/${id}/`).then(
      (result) => {
        let reportes = result.ultimo_resumo?.reporteandamento_resumo
        if (reportes) {
          sortReportes(reportes)
          result.requer_atencao = requerAtencao(reportes)
        }
        setIsLoaded(true)
        setItem(result)
        setReportes(reportes)
      },
      (error) => {
        setIsLoaded(true)
        setError(error)
      }
    )
  }, [id])

  useEffect(() => {
    if (item?.cor_fundo) {
      const boxShadowColor = chroma(item.cor_fundo).darken(2).hex()
      setStyle({
        backgroundColor: item?.cor_fundo,
        boxShadow: `0 0 0.5rem ${boxShadowColor}`
      })
    }
  }, [item?.cor_fundo])

  if (error) {
    return <Error>{error}</Error>
  }
  if (!isLoaded) {
    return <Loading />
  }
  const Resumo = () => (
    <div>
      <h2>RESUMO</h2>
      <S.DataHora>{dayjs(item?.atualizado_em).format('DD/MM HH:MM')}</S.DataHora>
      <S.Resumo>
        <div className="ui grid stackable">
          <div className="ten wide column" style={{backgroundColor: 'white', width:'62.5%', padding: '1em 1em 0em 1em'}}>
            <h3>Situação</h3>
            <EllipsisParagraph rows={3} htmlTitle='Situação' htmlText={ item?.ultimo_resumo?.situacao || ''}/>
          </div>
          <div className="six wide column" style={{backgroundColor: 'white', width:'62.5%', padding: '1em 1em 0em 1em'}}>
            <h3>Necessidade de apoio</h3>
            <EllipsisParagraph rows={3} htmlTitle='Necessidade de apoio' htmlText={item?.ultimo_resumo?.deliberacao || ''}/>
          </div>
        </div>
      </S.Resumo>
    </div>
  )
  const Reportes = () => (
    <div style={{paddingTop:'2em'}}>
      <h2>REPORTE / ANDAMENTOS</h2>
      
      <S.Reportes>
        <Swiper
          name="view-carousel"
          className="reportCarousel"
          spaceBetween={reportes?.length<2 ? 0: 10}
          slidesPerView={reportes?.length<2 ? 1: 2}
          breakpoints= {{
            320: {
              slidesPerView: 1,
            },
            // when window width is >= 480px
            800: {
                slidesPerView: 1,
            },
            // when window width is >= 640px
            1000: {
                slidesPerView: reportes?.length<2 ? 1: 2,
            }
          }}
          pagination={{
            "clickable": true
          }}
          navigation={true}
          watchOverflow={true}
        >

          {reportes?.map( (reporte,idx) =>
            <SwiperSlide key={idx}>
              <S.Reporte key={reporte.id} count={reportes.length}>
                <S.SiglaContainer>
                  <Sigla
                    reporte_obrigatorio={reporte.reporte_obrigatorio}
                    requer_atencao={reporte.requer_atencao}
                    size={tamanhoMaiorSigla([{ reportes }])}
                  >
                    <p>{reporte.sigla_departamento}</p>
                  </Sigla>
                </S.SiglaContainer>
                <S.ReporteHeader>
                  <div>{reporte.atualizado_por_colaborador?.nome}</div>
                  <div>{dayjs(reporte.atualizado_em).format("DD/MM HH:MM")}</div>
                </S.ReporteHeader>
                <S.ReporteBody>
                  <div className="ui grid stackable">
                    <div className="ten wide column">
                      <h3>Descrição</h3>
                      <EllipsisParagraph rows={4} htmlTitle='Descrição' htmlText={reporte.ultimos_andamentos}/>
                    </div>
                    <div className="six wide column">
                      <h3>Necessidade de apoio</h3>
                      <EllipsisParagraph rows={4} htmlTitle='Necessidade de apoio' htmlText={reporte.necessidade_apoio}/>
                    </div>
                  </div>
                </S.ReporteBody>
              </S.Reporte>
            </SwiperSlide>
          )}
        </Swiper>
      </S.Reportes>
    </div>
  )

  return (
    <S.Container style={style}>
      <div className='circle' >
        <Print setError={setError} title='Exportar como documento do word' name='btn-imprimir' extensao='docx' template='tema-prioritario' id={id} disabled={false} />
      </div>

      <Tag
        requer_atencao={item?.requer_atencao}
        novo={item?.novo}
        marginTop="-2.5rem"
      />
      {item?.novo && <S.Novo>NOVO</S.Novo>}
      
      <h1>{item?.titulo}</h1>
      <div className={'descricao'} dangerouslySetInnerHTML={{ __html: item?.descricao || '' }} />
      <S.ResumoContainer>
        <Resumo/>
        <Reportes/>
      </S.ResumoContainer>
      <Segment basic>
        <Button
          name="btn-viewer-fechar"
          onClick={() => history.goBack()}
        >Fechar</Button>
      </Segment>
    </S.Container>
  )
}
